export enum IndicatorFeatureFlag {
  NO_TIMELINE = 'NO_TIMELINE',
  NO_HEATMAP = 'NO_HEATMAP'
}

export enum VariablesValidationOperation {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO'
}

export enum VariablesValidationVariableType {
  VARIABLE = 'VARIABLE',
  INDEPENDENT_VARIABLE = 'INDEPENDENT_VARIABLE'
}

export enum OrderedComponentClassName {
  INDICATOR = 'OrderedIndicatorDTO',
  CHARACTERISTIC = 'OrderedCharacteristicDTO'
}

export enum PhenomenonQueryType {
  GET_PHENOMENA_BY_IDS = 'getPhenomenaByIds',
  GET_PHENOMENA_COMPARATIVE = 'getPhenomenaComparative'
}
